import { type FC } from 'react';
import { Alert } from 'react-bootstrap';
import { BsInfoCircle } from 'react-icons/bs';
import ButtonTooltip from '@editor2/components/ButtonTooltip';

import { tabsOpenedCounter } from './styles';

interface Props {
	tabsOpened: number;
}

const TabsOpenedCounter: FC<Props> = (props) => {
	const { tabsOpened } = props;

	const infoMessage =
		'Please, note that all changes are synchronized between the opened course tabs.';

	return (
		<>
			<Alert variant="info" className={tabsOpenedCounter}>
				<span>{`Tabs: ${tabsOpened}`}</span>
				<ButtonTooltip message={infoMessage}>
					<BsInfoCircle />
				</ButtonTooltip>
			</Alert>
		</>
	);
};

export default TabsOpenedCounter;
